import { useState } from "react";
import { Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ConfirmationContainer } from "../../../../../Modal/Confirmation/Confirmation";
import { InvestigationButton } from "../../components";
import { useParams } from "react-router";
import { summarizeInterviewAI } from "../../../../../../apis/apiAi";
import { useSnackbar } from "notistack";

export const AddConclusionWithIA = ({
  show,
  onHide,
  setConclusion,
  alias,
  interviewer,
  interview,
}) => {
  const theme = useTheme();
  const [t] = useTranslation("investigation");
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();

  const [isLoadingAIResponse, setIsLoadingAIResponse] = useState(false);

  const handleGenerateWithIA = async () => {
    setIsLoadingAIResponse(true);

    const fullName = interviewer.id;
    const [name, role] = fullName.split("-");

    const dataToSend = {
      report_id: id,
      investigation_alias: alias,
      name: name,
      position: role,
      type: interviewer.from,
    };

    try {
      const resp = await summarizeInterviewAI(dataToSend);
      setConclusion(resp.response);
      setIsLoadingAIResponse(false);
      onHide();
    } catch (error) {
      enqueueSnackbar(
        "No pudimos generar la conclusión. Asegúrate de completar todas las secciones de la entrevista para que el análisis sea preciso.",
        { variant: "error" }
      );
      console.error("Error al generar conclusión con IA:", error);
      setIsLoadingAIResponse(false);
    }
  };

  return (
    <ConfirmationContainer
      show={show}
      onHide={onHide}
      variant="rainbow"
      ethiquin="megaphone"
      sx={{ p: 2 }}
    >
      <Typography
        fontSize={28}
        fontWeight={700}
        color="pink.main"
        textAlign="start"
      >
        {t("¡Importante!")}
      </Typography>
      <Typography mt={2}>
        {t(
          "Verifica que todas las secciones de la entrevista estén completas para que el sistema pueda analizar toda la información y dar la conclusión."
        )}
      </Typography>
      <br />
      <Typography>
        {t("Para realizar esta acción se necesita")}:&nbsp;
        <span style={{ color: theme.palette.red.main, fontWeight: 600 }}>
          3 {t("créditos")}
        </span>
      </Typography>
      <Typography
        color="primary.main"
        mt={1.5}
        mb={3.5}
        textAlign="start"
        fontSize={16}
        fontWeight={600}
      >
        {t("¿Estás seguro de seguir adelante?")}
      </Typography>
      <Stack direction="row" spacing={2} mt={2} justifyContent="flex-end">
        <InvestigationButton
          label={t("CANCELAR")}
          onClick={onHide}
          variant="main"
          outlined
          loading={isLoadingAIResponse}
        />
        <InvestigationButton
          label={t("CONFIRMAR")}
          onClick={handleGenerateWithIA}
          variant="main"
          loading={isLoadingAIResponse}
        />
      </Stack>
    </ConfirmationContainer>
  );
};
